import React from "react";
import { useState } from "react";
import { useRouter } from "next/router";

import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import ProfileCard from "./ProfileCard";
import DashboardWrapper from "../../../../hoc/DashboardWrapper";
import { useSelector } from "react-redux";

interface props {
  children?: React.ReactNode;
}

export const DashboardLayout = ({ children }: props) => {
  const [section, setSection] = useState("profile");
  const [proMember, setProMember] = useState(false);
  const userAttributes = useSelector((state: any) => {
    return state.auth?.user?.attributes;
  });

  const allSections = ["profile", "shortlisted"];
  {
    process.env.NEXT_PUBLIC_PYP_ENABLE === "true" &&
      allSections.push("posted-properties");
  }
  const router = useRouter();

  return (
    <DashboardWrapper>
      <Header />
      <ProfileCard promember={proMember} />
      <div className="px-customPaddingMobile lg:flex lg:px-customPadding lg:pb-10 lg:pt-[88px] 2xl:px-0 2xl:mx-auto 2xl:w-[1340px]">
        <div className="flex lg:inline-block space-x-4 space-y-0 lg:space-x-0 mt-12 lg:mt-0  lg:space-y-4">
          {allSections.map((item, index) => (
            <div
              key={`item-${index}`}
              className={`uppercase font-spaceGrotesk font-normal text-mobile-body-sm leading-4 lg:text-web-h3  lg:leading-[48px] lg:w-[200px] lg:pl-[19px] py-2 lg:py-3 border-b-2 lg:border-b-0 lg:border-l-2 hover:cursor-pointer hover:bg-slate-50 ${
                router.pathname?.split("dashboard/")[1] === item ||
                (!router.pathname?.split("dashboard/")[1] && item === "profile")
                  ? " border-brand-orange text-brand-bgBlack"
                  : "border-transparent text-brand-textLightGrey"
              }  `}
              onClick={() => {
                if (userAttributes.length === 2) {
                  setSection(item);
                  router.push(`/dashboard/${item}`);
                }
              }}
            >
              {item.replace(/-/g, " ")}
            </div>
          ))}
        </div>
        <div className="mt-[76px] lg:mt-0 lg:ml-[60px] mid:ml-[97px]  w-full">
          {children}
        </div>
      </div>
      <Footer />
    </DashboardWrapper>
  );
};

export default DashboardLayout;
